import React from 'react';
import { X, Check } from 'lucide-react';
const comparison = [['Improvisás el precio en cada reunión', 'Usás un criterio claro en cada caso'], ['Bajás el precio ante presión', 'Defendés tu precio con palabras simples'], ['Frenás el trabajo si no estás encima', 'Dejás pasos claros para seguir avanzando'], ['Tardás horas en cada propuesta', 'Usás guiones y modelos listos'], ['No sabés qué ganás cada mes', 'Entendés tus cobros y tus gastos'], ['No sabés cómo usar IA', 'Usás IA para resolver tareas concretas']];
export function UpsellComparison() {
  return <section className="bg-white px-6 py-24 lg:px-8" data-id="element-257">
      <div className="mx-auto max-w-5xl" data-id="element-258">
        <header className="mb-12 text-center" data-id="element-259">
          <h2 className="text-3xl font-extrabold text-brand-navy md:text-5xl" data-id="element-260">
            Mirá qué cambia cuando trabajás con un sistema
          </h2>
          <p className="mt-3 text-sm text-brand-navy/55 md:hidden" data-id="element-261">
            ← Deslizá para ver la tabla →
          </p>
        </header>

        <div className="overflow-x-auto rounded-2xl border border-brand-light" data-id="element-262">
          <div className="min-w-[640px]" data-id="element-263">
            <div className="grid grid-cols-2 font-extrabold" data-id="element-264">
              <div className="border-b border-brand-light p-5 text-brand-navy/60" data-id="element-265">
                Sin el Megapack
              </div>
              <div className="border-b-2 border-brand-accent bg-brand-light p-5 text-brand-accent" data-id="element-266">
                Con el Megapack PRO
              </div>
            </div>
            {comparison.map(([without, withSystem]) => <div key={without} className="grid grid-cols-2 border-b border-brand-light last:border-b-0" data-id="element-267">
                <div className="flex items-start gap-3 p-5 text-gray-400" data-id="element-268">
                  <X className="mt-0.5 h-5 w-5 shrink-0 text-red-500" data-id="element-269" />
                  {without}
                </div>
                <div className="flex items-start gap-3 bg-brand-light p-5 font-bold text-brand-navy" data-id="element-270">
                  <Check className="mt-0.5 h-5 w-5 shrink-0 text-brand-green" data-id="element-271" />
                  {withSystem}
                </div>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}